import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'event',
    path: 'id',
  })

  return {
    variables: {
      id,
    },
  }
}
